import { render } from "./App.vue?vue&type=template&id=2aa8f8df"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2aa8f8df&lang=css"
import "./App.vue?vue&type=style&index=1&id=2aa8f8df&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__